import {
  eliminarVisitaOffline,
  marcarClienteFinalizadoOffline,
  marcarClienteEstadoOffline,
  obtenerVisitasPendientes,
} from '../db/indexedDB';
import { API_BASE, formatApiError, getToken, isAuthError, notifySessionExpired } from '../services/api';

const buildVisitPayload = (visita) => ({
  operation_id: visita.operation_id,
  cliente: visita.cliente,
  visitaData: visita.visitaData,
  fotos: visita.fotos,
  nombre_tecnico: visita.nombre_tecnico,
});

export const sincronizarVisitasPendientes = async () => {
  const pendientes = await obtenerVisitasPendientes();
  if (!pendientes.length || !navigator.onLine) {
    return { total: pendientes.length, synced: 0, failed: 0 };
  }

  let synced = 0;
  let failed = 0;

  for (const visita of pendientes) {
    try {
      const res = await fetch(`${API_BASE}/visitas/completar`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildVisitPayload(visita)),
      });
      const data = await res.json().catch(() => null);
      if (!res.ok) {
        if (isAuthError(res, data)) {
          notifySessionExpired();
          failed += 1;
          break;
        }
        throw new Error(formatApiError(res, data, 'No se pudo sincronizar una visita pendiente.'));
      }

      await eliminarVisitaOffline(visita.id);
      if (visita.visitaData?.resultado_visita === 'finalizada') {
        await marcarClienteFinalizadoOffline(visita.cliente);
      } else {
        await marcarClienteEstadoOffline(
          visita.cliente,
          'revision_admin',
          { intento_offline_sincronizado: true }
        );
      }
      synced += 1;
    } catch (error) {
      console.error('Error sincronizando visita offline', error);
      failed += 1;
    }
  }

  const result = { total: pendientes.length, synced, failed };
  window.dispatchEvent(new CustomEvent('visitas:offline-sync-complete', { detail: result }));
  return result;
};
